import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_USERS } from '@/lib/constants/api'
import getUserModel from './models/user'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const user = {
  namespaced: true,
  state: {
    ...getUserModel()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearUser: (state) => {
      state.id = null
      state.firstName = null
      state.lastName = null
      state.password = null
      state.emailAddress = null
      state.active = true
      state.securityRoles = []
    },
    setUser: (state, user) => {
      state.id = user.id
      state.firstName = user.firstName
      state.lastName = user.lastName
      state.fullName = user.fullName
      state.emailAddress = user.emailAddress
      state.password = user.password
      state.active = user.active
      state.securityRoles = user.securityRoles || []
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_USERS, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_USERS, data: state })
    },
    getUser: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting user, please wait...' })

      return api.doGet({ path: PATH_USERS, parameters: { id } })
        .then(json => json.data)
        .then(data => Array.isArray(data) ? data[0] : data)
        .then(user => {
          commit('updateStatus', { status: COMPLETE })
          commit('setUser', user)

          return user
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getUserByEmail ({ commit, dispatch }, emailAddress) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting user, please wait...' })
      return api.doGet({ path: PATH_USERS, parameters: { emailAddress } })
        .then(json => json.data)
        .then(user => {
          if (user.length > 0) {
            user = user[0]
          }
          commit('updateStatus', { status: COMPLETE })
          commit('setUser', user)

          return user
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveUser: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving user, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        if (!response.data) {
          if (response.errorMessage) {
            throw new Error(response.errorMessage)
          }
          throw new Error('Unable to save user. Check required fields.')
        }

        commit('clearUser')
        commit('updateStatus', { status: COMPLETE })
        notifySuccess(dispatch, 'User saved')

        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, error || 'Unable to save user. Try again later')
        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearUser: ({ commit }) => {
      commit('clearUser')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default user
